<app-enfaf-modal [title]="data ? 'Editar ejemplo' : 'Nuevo ejemplo'" svgIcon="video-dark" (onClose)="closeModal()"
    (onConfirm)="onConfirm()" buttonCancelText="Cancelar" buttonConfirmText="Guardar"
    [disableCancelButton]="isLoading()" [disableConfirmButton]="!isFormValid || isLoading() || isUploading()"
    [isLoading]="isLoading()">
    <form class="form" [formGroup]="form">
        <!-- Type selector -->
        <div class="type-selector">
            <button type="button" class="type-btn" [class.type-btn--active]="selectedType() === 'video'"
                (click)="selectType('video')">
                Vídeo
            </button>
            <button type="button" class="type-btn" [class.type-btn--active]="selectedType() === 'image'"
                (click)="selectType('image')">
                Imagen
            </button>
        </div>

        <!-- Title -->
        <enfaf-input color="light" label="Título" placeholder="Título del ejemplo" [maxlength]="100"
            [control]="form.controls.title"></enfaf-input>

        <!-- Description -->
        <app-enfaf-textarea-light [control]="form.controls.description" label="Descripción"
            placeholder="Descripción opcional" [rows]="3" [maxlength]="300"></app-enfaf-textarea-light>

        <!-- Vimeo ID (video only) -->
        @if (selectedType() === 'video') {
        <enfaf-input color="light" label="Vimeo ID" placeholder="ej. 1148620047"
            [errorLabel]="form.controls.vimeoId.hasError('pattern') ? 'El formato del ID no es válido (9 o 10 dígitos)' : 'Campo requerido'"
            [control]="form.controls.vimeoId"></enfaf-input>
        }

        <!-- Image upload (image only) -->
        @if (selectedType() === 'image') {
        <app-enfaf-input-file-dragger-light accept=".jpg,.jpeg,.png,.gif,.webp" [acceptMultiple]="false"
            [maxFileSize]="5242880" title="Arrastra o suelta la imagen aquí" buttonText="Seleccionar imagen"
            [localFiles]="localImageFiles" [currentFiles]="currentImageFiles"
            (filesDropped)="onImageFilesDropped($event)" (currentFileDeleted)="onCurrentImageDeleted()"
            [confirmDelete]="false" [fullWidth]="true"></app-enfaf-input-file-dragger-light>
        }
    </form>

    <!-- Vimeo preview -->
    @if (selectedType() === 'video' && safeUrl) {
    <div class="video-container">
        <div class="video">
            <iframe [src]="safeUrl" frameborder="0" allow="autoplay; fullscreen; picture-in-picture"></iframe>
        </div>
    </div>
    }
</app-enfaf-modal>